var app = angular.module("leonardo");

var UserLoginController = function($scope, $state, $rootScope, $location, CookieService, LoginService, $timeout,
                                   NotificationService, FormErrorsService, BroadcastChannelService, AuthService,
                                   ConfigThemeService) {

  $scope.remember = false;
  $scope.read_email = true;
  $scope.read_password = false;
  $scope.configThemeService = ConfigThemeService;
  $scope.errorSSO = !isNull($state.params.errorSSO) ?
    LoginService.ERROR_SSO_OPTIONS.find(
      (e) => e.id === $state.params.errorSSO.toString()
    ) : null;
  $scope.step = !isNull($state.params.errorSSO) ? 3 : 1;
  $scope.token = $state.params.token;
  $scope.session_id = $state.params.session_id;
  
  // Iframe loading screen flags
  $scope.isInIframe = $rootScope.isInIframe;
  $scope.hasToken = !!localStorage.getItem('jwt_token');

  $scope.init = function() {   
    var remember_email = localStorage.getItem('remember_email');
    $scope.email = remember_email || '';
    $scope.password = '';
    $scope.remember = !!remember_email;
    if ($scope.token) {
      localStorage.setItem('jwt_token', $scope.token);
      localStorage.setItem('session_id', $scope.session_id);
      BroadcastChannelService.postMessage({
        type: 'login',
        message: 'User logged in'
      });
      localStorage.setItem('auth_provider', 'SSO');
      $state.go('login-redirection');
    }
  };

  $scope.backToHome = function () {
    $location.search('errorSSO', null);
    $scope.step = 1;
  };

  $scope.continue = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.email.$error.required) {
      FormErrorsService.goToError();
    }
    else {
      AuthService.validateUser($scope.email, true).then(function (result){
        const data = result?.data || result;
        if (data?.action === 'redirect') {
          //Remember me functionality for SSO users
          if ($scope.remember) {
            localStorage.setItem('remember_email', $scope.email);
          }
          else if(localStorage.getItem('remember_email')) {
            localStorage.removeItem('remember_email');
          }
          window.location.replace(data?.url);
        }
        else {
          $scope.Form.$setUntouched();
          $scope.Form.$setPristine(); 
          $timeout(function (){
            $scope.step++;
          }, 100);
          $timeout(function (){
            $($('#fpassword').find('input')[0]).focus();
          }, 300);
        }
      });
    }
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if ($scope.remember) {
      localStorage.setItem('remember_email', $scope.email);
    }
    else if(localStorage.getItem('remember_email')) {
      localStorage.removeItem('remember_email');
    }
    LoginService.login($scope.email, $scope.password, true).catch(function() {
      if ($scope.invalidUser !== undefined) {
        $scope.invalidUser = true;
        $timeout(function() {
          $scope.invalidUser = false;
        }, 2000);
      } else {
        NotificationService.error('Username or Password are not correct');
      }
    });
  };

  $scope.goToPrevStep = function(e){
    if(e.keyCode == 13){
      $scope.step = 1;
    }
    return
  }

  $scope.checkCheckbox= function(e){
    if(e.keyCode == 32){
      if($(e.target).hasClass('terms')){
        $(e.target).prev().click();
      }
      else{
        $(e.target)[0].click();
      }
    }
    if((e.keyCode == 13) && !($(e.target)[0].className.includes('remember_me'))){
      window.open('https://www.leonardo247.com/privacy-policy/', '_blank');
    }
  }

  $timeout(function(){
    $scope.init();
  }, 0);
};

app.controller('UserLoginController', ['$scope', '$state', '$rootScope', '$location', 'CookieService', 'LoginService',
  '$timeout', 'NotificationService', 'FormErrorsService', 'BroadcastChannelService', 'AuthService', 'ConfigThemeService',
  UserLoginController]);
